"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION_ROLES = void 0;
var PRODUCTION_ROLES;
(function (PRODUCTION_ROLES) {
    PRODUCTION_ROLES["VIEW_WORK_ORDER"] = "view-work-order";
    PRODUCTION_ROLES["SEARCH_WORK_ORDERS"] = "search-work-orders";
    PRODUCTION_ROLES["CREATE_WORK_ORDER"] = "create-work-order";
    PRODUCTION_ROLES["MODIFY_WORK_ORDER"] = "modify-work-order";
    PRODUCTION_ROLES["COMPLETE_WORK_ORDER"] = "complete-work-order";
    PRODUCTION_ROLES["ASSIGN_WORK_ORDER"] = "assign-work-order";
})(PRODUCTION_ROLES = exports.PRODUCTION_ROLES || (exports.PRODUCTION_ROLES = {}));
//# sourceMappingURL=production.roles.js.map